<template>
  <b-container>
    <h2>{{ isEntry ? $t('livestock_incoming') : $t('livestock_outgoing') }}</h2>
    <LoadingSpinner :loading="getMovementId !== null && loading" />

      <div v-if="getMovementId === null || !loading">
            <div class="btn-update-cancel">
              <button class="btn btn-outline-success btn-sm me-2 btn-lg w-80" type="submit" @click="saveAdd">
                <i class="fas fa-save"></i> {{ movement.id ? $t('update') : $t('add') }}
              </button>
              <button class="btn btn-outline-secondary btn-sm me-2 btn-lg w-80" type="reset" @click="cancelAdd">
                <i class="bi bi-x"></i> {{ $t('cancel') }}
              </button>
            </div>

      <!-- Movement Form -->
      <MovementForm 
          ref="movementForm"
          :animalOptions="animalOptions"
          :movementData="movement"
          :sourceOptions="sourceOptions"
          :destinationOptions="destinationOptions"
          :isEntry="isEntry"
          :totalExpenses="totalExpenses"
          @movementSaved="saveMovement"/>
      <!-- Tabs for Detail Movement and Expenses Movement -->
      <b-tabs class="mt-1">
        <b-tab title="Detail Movement">
          <DetailMovementTable ref="detailMovementTable" :detailMovements="detailMovements" :movementId="movement.id" />
        </b-tab>
        <b-tab title="Expenses Movement">
          <ExpensesMovementTable
              ref="expensesMovementTable"
              :expenseMovements="expenseMovements"
              :movementId="movement.id"
              :expenseOptions="expenseOptions"
              @updateTotalExpenses="updateTotalExpenses"
            />
        </b-tab>
      </b-tabs>
    </div>
  </b-container>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex';
import MovementForm from "./MovementForm.vue";
import DetailMovementTable from "./DetailMovementTable.vue";
import ExpensesMovementTable from "./ExpensesMovementTable.vue";
import Movement from '../model/Movement';

import { AnimalService, DestinationService, SourceService, ExpenseService, MovementService } from '../api';

import { Message } from "../libjs/alertService";
import LoadingSpinner from "@/components/LoadingSpinner.vue"; // Import the new component

export default {
  components: { LoadingSpinner, MovementForm, DetailMovementTable, ExpensesMovementTable },
  data() {
    return {
      movement: {},
      animalOptions: [],
      sourceOptions: [],
      destinationOptions: [],
      expenseOptions: [],
      detailMovements: [],
      expenseMovements: [],
      loading: true, // Set initial loading state to true
      totalExpenses: 0, // Add totalExpenses data property
    };
  },
  computed: {
  ...mapGetters(['getMovementId']),
  isEntry() {
    //console.log('entry ' + (this.$route.path === '/entry'))
    return this.$route.path === '/incoming';
  },
  isExit() {
    //console.log('exit ' + (this.$route.path === '/exit'))
    return this.$route.path === '/outgoing';
  }
  },
  methods: {
    async fetchMovement () {
      try {
          this.loading = true;  // Set loading to true when fetching data
          const data  = await MovementService.getMovement(this.getMovementId);
          const { detailMovements, expenseMovements, ...movementForm } = data;
          console.log(movementForm);
          this.movement = movementForm
          this.detailMovements = detailMovements
          this.expenseMovements = expenseMovements
          this.loading = false;  // Set loading to false once the data is fetched
        } catch (error) {
          Message("danger", this.$t("message.delete_failed"));
          this.loading = false;  // Set loading to false in case of an error as well
        }
    },
    async fetchAnimals() {
      try {
        const response = await AnimalService.listAnimal();
        this.animalOptions = response;
      } catch (error) {
        console.error("Error fetching animals:", error);
      }
    },
    async fetchSources() {
      try {
        const response = await SourceService.listSources();
        this.sourceOptions = response;
      } catch (error) {
        console.error("Error fetching sources:", error);
      }
    },
    async fetchDestinations() {
      try {
        const response = await DestinationService.listDestination();
        this.destinationOptions = response;
      } catch (error) {
        console.error("Error fetching destination:", error);
      }
    },
    async fetchExpenses() {
      try {
        const response = await ExpenseService.listExpense();
        this.expenseOptions = response;
      } catch (error) {
        console.error("Error fetching expenses:", error);
      }
    },
    async validateBeforeSave() {
      try {
        // Validate MovementForm
        const isMovementFormValid = await this.$refs.movementForm.validateForm();
        if (!isMovementFormValid) {
          Message("warning","MovementForm validation failed");
          return;
        }
        // Validate DetailMovementTable
        const isDetailMovementValid = await this.$refs.detailMovementTable.validateTable();
        if (!isDetailMovementValid) {
          Message("warning","DetailMovementTable validation failed");
          return;
        }
        // Validate ExpensesMovementTable
        const isExpensesMovementValid = await this.$refs.expensesMovementTable.validateTable();
        if (!isExpensesMovementValid) {
          Message("warning","ExpensesMovementTable validation failed");
          return;
        }        
      } catch (error) {
        Message("danger","Error during validation:", error);
      }

    },
    adapteData(){
      const formData = this.$refs.movementForm.movement;
      console.log('this.isEntry ' + this.isEntry)
      console.log('valeu ' + (this.isEntry ? 'e' : 's'))
      formData.e_s = this.isEntry ? 'in' : 'out'
      let detailData = this.$refs.detailMovementTable.details;
      let expenseData = this.$refs.expensesMovementTable.expenses;
      // Remove 'id' from detailMovements and expenseMovements
      if(formData.id === null){
        detailData.forEach(function(el){ delete el.id });
        expenseData.forEach(function(el){ delete el.id });
      }
      // Construct Movement object using the Movement class
      const movementData = new Movement(
        formData.id,
        formData.e_s,
        formData.date,
        formData.nombre,
        formData.poidTot,
        formData.prixTot,
        formData.source,
        formData.destination,
        formData.remarque,
        formData.addDetailMovement,
        detailData,
        expenseData,
        formData.operation
      );
    return movementData
    },
    async saveAdd() {
      this.validateBeforeSave()
      const data = this.adapteData()
      console.log("Constructed Movement Object:", JSON.stringify(data));
      try {
        console.log('data ' + JSON.stringify(data))
        if (data.id) {
          await MovementService.updateMovementIncoming(data.id, data);
          Message("success", this.$t("message.update_success"));
          console.log('redirection-cas-1')
        } else {
          await MovementService.createMovementIncoming(data);
          Message("success", this.$t("message.add_success"));
        }
        console.log('redirection')
        this.$router.push('/ListOfMovement');
      } catch (error) {
        Message("danger", this.$t("message.operation_failed"));
      }
    },
    cancelAdd() {
      console.log('cancelAdd')
      this.setMovementId(null)
      this.$router.push('/ListOfMovement');
    },
    saveMovement(movement) {
      console.log("Movement saved in parent:", movement);
      this.movement = { id: Date.now(), ...movement }; // Simulate saving and generating ID
    },
    // Add a method to handle totalExpenses updates
    updateTotalExpenses(value) {
      this.totalExpenses = value;
    },
    ...mapMutations(['setMovementId'])
  },
  beforeRouteLeave(to, from, next) {
    // Reset the data when navigating away from this page
    this.$refs.movementForm.resetForm()
    this.$refs.detailMovementTable.resetTable();
    this.$refs.expensesMovementTable.resetTable();
    
    next();  // Proceed with the navigation
  },
  mounted() {
    this.fetchAnimals();
    this.fetchSources();
    this.fetchDestinations()
    this.fetchExpenses();
    if(this.getMovementId){ //it will execute only in case of update
      this.fetchMovement();
    }    
  }
};
</script>

<style scoped>

.container {
    margin-top: 20px;
    border: 1px solid #ddd;
    padding: 0px;
    border-radius: 10px;
  }

  h2 {
    background-color: #47c399;
    border-radius: 10px 10px 0 0;
    color: azure;
    padding: 3px;
    text-align: justify;
    padding-left: 15px;
  }
</style>
